import clsx from "clsx";
import { Grid, FilterComponent } from "@client/shared/components";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import style from "./style";
import { globalStyles, noop } from "@client/shared/constants";

const WhitelistComponentView = ({
  columns = [],
  entries = [],
  filters = [],
  totalEntries = 0,
  search = "",
  pageSize = 5,
  pageNumber = 1,
  isLoading = false,
  isFiltering = false,
  handleExport = noop,
  handleFilterClose = noop,
  handlePageNumberChange = noop,
  handlePageSizeChange = noop,
  onGridReady = noop,
  handleSearchChange = noop,
  handleSelectionChange = noop,
  handleAllSelectionChange = noop,
  handleSorting = noop,
  filterData = noop,
  order = null,
  orderBy = "",
}) => {
  // console.log(`order`, order);
  return (
    <>
      <Box>
        <Box sx={style.pageHeadingWrapper}>
          <Typography style={style.pageHeading} variant="h5">
            Whitelist
          </Typography>
          <Typography sx={style.pageHeadingCaption} variant="caption">
            Clients are managed through the PSi Entitlement system.
          </Typography>
          <span style={style.pageHeadingMarker}></span>
        </Box>
      </Box>
      <Box sx={style.actionsWrapper}>
        <Box sx={style.actionBtnsLeft}></Box>
        <Box sx={style.actionBtnsRight}>
          {/* <img
            alt="Filter data"
            // className={clsx('action', {
            //   'c-pointer': !(isLoading || isFiltering),
            // })}
            style={{ cursor: "pointer" }}
            onClick={filterData}
            src={
              isLoading ? "/assets/filter-disabled.svg" : "/assets/filter.svg"
            }
          /> */}
          <FilterComponent
            filterConfig={filters}
            onFilterApply={filterData}
            appliedFilters={isFiltering}
            // disabled={isEditing}
            onFilterClose={handleFilterClose}
          />
          <img
            alt="Export data"
            className={clsx("action", { "c-pointer": !isLoading })}
            style={{ cursor: "pointer" }}
            src={
              isLoading ? "/assets/export-disabled.svg" : "/assets/export.svg"
            }
            onClick={handleExport}
          />
        </Box>
      </Box>
      <Grid
        hasLoader
        keepSelection
        columns={columns}
        rows={entries || []}
        filters={filters}
        isFiltering={isFiltering}
        isLoading={isLoading}
        onFilterClose={handleFilterClose}
        onReady={onGridReady}
        onPageNumberChange={handlePageNumberChange}
        onPageSizeChange={handlePageSizeChange}
        onSelectionChange={handleSelectionChange}
        onSelectAll={handleAllSelectionChange}
        order={order}
        orderBy={orderBy}
        onSortChange={handleSorting}
        pageNumber={pageNumber}
        pageSize={pageSize}
        totalRows={totalEntries}
        classes={{
          container: style.tablePaper,
        }}
      />
    </>
  );
};

export default WhitelistComponentView;
